import React, { useState } from 'react';

import {
    Link
} from '@material-ui/core';
import PasswordIcon from '@material-ui/icons/VpnKey';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyAlert from '../AuthBodyAlert';
import AuthBodyTextFieldRow from '../AuthBodyTextFieldRow';
import AuthBodyTextField from '../AuthBodyTextField';
import AuthBodyButton from '../AuthBodyButton';
import AuthBodyContent from '../AuthBodyContent';

function ResetPasswordBody () {
    const authenticity_token = document.querySelector('meta[name=\'csrf-token\']').getAttribute('content');

    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [resetSuccess, setResetSuccess] = useState(false);
    const [errors, setErrors] = useState({});

    function handleFormSubmit (e) {
        e.preventDefault();
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams({
            authenticity_token: authenticity_token,
            utf8: '✓',
            'user[password]': password,
            'user[password_confirmation]': passwordConfirm,
            'user[reset_password_token]': url.searchParams.get('reset_password_token')
        });

        fetch('/user/password?reset_password_token=' + url.searchParams.get('reset_password_token'), {
            method: 'PUT',
            body: searchParams.toString(),
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setResetSuccess(true);
                } else {
                    if (data.errors && Object.keys(data.errors).length > 0) {
                        setErrors({
                            ...data.errors,
                            resetToken: data.errors.reset_password_token ? "Reset token has expired, please retry resetting your account's password" : null
                        });
                    }
                }
            })
            .catch((err) => {
                setErrors({
                    resetToken: err.reset_password_token ? "Reset token has expired, please retry resetting your account's password" : null
                });
            });
    }

    return resetSuccess ? (
        <AuthBody>
            <AuthBodyTitle>
                Success
            </AuthBodyTitle>
            <AuthBodyContent>
                Your password has been changed successfully
            </AuthBodyContent>
            <Link href="/user/login">
                <AuthBodyButton>
                    Log In
                </AuthBodyButton>
            </Link>        
        </AuthBody>
    ) : (
        <AuthBody onSubmit={handleFormSubmit}>
            <AuthBodyTitle>
                Reset your password
            </AuthBodyTitle>
            { Boolean(errors.resetToken ) && <AuthBodyAlert severity="error" >{ errors.resetToken }</AuthBodyAlert> }
            <div>
                <AuthBodyTextFieldRow
                    icon={<PasswordIcon color="primary" />}
                    error={Boolean(errors.password)}
                >
                    <AuthBodyTextField
                        label="New Password"
                        type="password"
                        name="user[password]"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        error={Boolean(errors.password)}
                        helperText={Boolean(errors.password) ? 'Password: ' + errors.password[0] : null}
                    />
                </AuthBodyTextFieldRow>
                <AuthBodyTextFieldRow
                    icon={<PasswordIcon color="primary" />}
                    error={Boolean(errors.password_confirmation)}
                >
                    <AuthBodyTextField
                        label="Confirm Password"
                        type="password"
                        name="user[password_confirmation]"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        error={Boolean(errors.password_confirmation)}
                        helperText={Boolean(errors.password_confirmation) ? 'Confirm password: ' + errors.password_confirmation[0] : null}
                    />
                </AuthBodyTextFieldRow>
            </div>
            <AuthBodyButton
                type="submit"
            >
                Save
            </AuthBodyButton>
        </AuthBody>
    );
}

export default ResetPasswordBody;